import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { SIMPLE_CHALLENGE_FRAGMENT } from '../fragments'

const CHALLENGES_QUERY = gql`
  query challenges {
    challenges {
      results {
        ...SimpleChallengeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${SIMPLE_CHALLENGE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default CHALLENGES_QUERY
